import { FollowPathInfo } from "./FollowPathInfo";
import { SetTractorStateInfo } from "./TractorStateInfo";
import { Task } from "protos/rtc/jobs";
import React, { FC } from "react";

interface AdditionalTaskInfoProps {
  task: Task;
}
export const AdditionalTaskInfo: FC<AdditionalTaskInfoProps> = ({ task }) => {
  return (
    <div className="flex flex-col">
      {task.followPath && <FollowPathInfo followPath={task.followPath} />}
      {task.tractorState && (
        <SetTractorStateInfo setTractorState={task.tractorState} />
      )}
    </div>
  );
};
